<template>
    <div class="service_list mt-5">
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <ul  v-if="goodsList.length > 0">
                <li  v-for="(item, index) in goodsList" :key="index" @click="$router.push({name:'FuwuGoodsDetail',query:{o2o_fuwu_goods_id:item.o2o_fuwu_goods_id}})">
                        <div class="p_img">
                            <img :src="item.o2o_fuwu_goods_image_url"/>
                        </div>
                        <div class="p_info">
                            <div class="title">{{item.o2o_fuwu_goods_name}}</div>
                            <div class="desc">{{item.o2o_fuwu_goods_advword}}</div>
                            <div class="price">{{item.o2o_fuwu_goods_default_price}}元{{item.o2o_fuwu_goods_spec_quantity>1?'起':''}}       </div>
                        </div>

                </li>
            </ul>
            <empty-record v-else></empty-record>
        </div>

    </div>
</template>

<script>
import { Indicator, Toast, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getGoodsList } from '../../../api/fuwuGoods'
export default {
  name: 'Service',
  data () {
    return {
      organization_id: this.$route.query.organization_id ? this.$route.query.organization_id : '',
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      pageTotal: 1, // 总页数
      goodsList: [] // 服务列表
    }
  },
  components: {
    EmptyRecord
  },
  created () {

  },
  methods: {

    getGoodsList (ispush) {
      Indicator.open()
      let params = this.params
      getGoodsList(params, { o2o_fuwu_organization_id: this.organization_id }).then(res => {
        Indicator.close()

        if (ispush) {
          this.goodsList = this.goodsList.concat(res.result.o2o_fuwu_goods_list)
        } else {
          this.goodsList = res.result.o2o_fuwu_goods_list
        }
        this.pageTotal = res.result.page_total
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore && this.params.page <= this.pageTotal) {
        this.loading = false
        this.getGoodsList(true)
      }
    },

    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.goodsList = []
      this.loadMore()
    }
  }
}
</script>

<style scoped>
    .service_list{background:#fff;}
    .service_list li{padding: .5rem .45rem;height:5rem;border-bottom: 1px solid #e6e6e6;}
    .service_list li .p_img{width: 5rem;height: 5rem;float:left;}
    .service_list li .p_img img{width:100%;height:100%;}
    .service_list li .p_info{margin-left:5.5rem;}
    .service_list li .title{font-size:.8rem;margin-top:.5rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
    .service_list li .desc{margin-top: .3rem;margin-bottom: .5rem;color: #a2a2a2;font-size: .6rem;line-height: 1rem;height: 2rem;font-weight: 400;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;box-orient: vertical;overflow: hidden;}
    .service_list li .price{color: #e93b3d;font-size: .7rem;}
</style>
